// In-memory cache for the main Dashboard.
// Survives in-app navigation (card → list → back) so the API is not called again,
// but is lost on a full page reload / login, and cleared on logout.
let dashboardCache = null;

export const getDashboardCache = () => dashboardCache;

export const setDashboardCache = (key, data) => {
	dashboardCache = { key, data, scrollY: 0 };
};

export const saveDashboardScroll = (scrollY) => {
	if (dashboardCache) dashboardCache.scrollY = scrollY;
};

export const clearDashboardCache = () => {
	dashboardCache = null;
	sessionStorage.removeItem("dashboardFilters");
};
